import { state } from '../state';
import { post } from '../api';
import { approvalCard } from '../components/approval-card';
import { showModal, closeModal, modalFrame } from '../components/modal';
import { showToast } from '../components/toast';
import { validateRequired, clearAllErrors } from '../components/form-validation';
import { iconPlus } from '../icons';
import type { Approval } from '../types';

function esc(str: string): string {
  const el = document.createElement('div');
  el.textContent = str;
  return el.innerHTML;
}

function openSubmitApproval(reload: () => void): void {
  showModal(modalFrame('Submit Approval',
    `<div class="form-group">
      <label class="form-label" for="f-type">Type</label>
      <input id="f-type" class="form-input" placeholder="expense / leave / access" required>
    </div>
    <div class="form-group">
      <label class="form-label" for="f-subject">Subject</label>
      <input id="f-subject" class="form-input" required>
    </div>
    <div class="form-group">
      <label class="form-label" for="f-reason">Reason</label>
      <textarea id="f-reason" class="form-input" rows="3"></textarea>
    </div>
    <div class="form-group">
      <label class="form-label" for="f-amount">Amount</label>
      <input id="f-amount" class="form-input" type="number" step="0.01">
    </div>`,
    `<button class="btn btn-secondary" id="modal-cancel">Cancel</button>
     <button class="btn btn-primary" id="modal-save">Submit</button>`
  ));
  document.getElementById('modal-close')?.addEventListener('click', closeModal);
  document.getElementById('modal-cancel')?.addEventListener('click', closeModal);
  document.getElementById('modal-save')?.addEventListener('click', () => {
    clearAllErrors();
    const typeValid = validateRequired('f-type', 'Type');
    const subjectValid = validateRequired('f-subject', 'Subject');
    if (!typeValid || !subjectValid) return;

    const type = (document.getElementById('f-type') as HTMLInputElement).value.trim();
    const subject = (document.getElementById('f-subject') as HTMLInputElement).value.trim();
    const reason = (document.getElementById('f-reason') as HTMLTextAreaElement).value.trim();
    const amtRaw = (document.getElementById('f-amount') as HTMLInputElement).value;
    const amount = amtRaw ? parseFloat(amtRaw) : null;
    post<Approval>('/api/approvals/add', { type, subject, reason, amount, server_id: state.currentServer, requested_by: state.ownerId || 'owner' })
      .then(() => { closeModal(); showToast('Approval submitted', 'ok'); reload(); })
      .catch(e => showToast(String(e), 'err'));
  });
}

function handleAction(action: string, id: string, reload: () => void): void {
  const status = action === 'approve' ? 'approved' : 'denied';
  post<Approval>(`/api/approvals/${encodeURIComponent(id)}/decide`, { status, decided_by: state.ownerId || 'owner' })
    .then(() => { showToast(`Approval ${esc(status)}`, 'ok'); reload(); })
    .catch(e => showToast(String(e), 'err'));
}

export function renderApprovals(body: HTMLElement): void {
  const sid = state.currentServer;
  const approvals = sid
    ? state.approvals.filter(a => a.server_id === sid)
    : state.approvals;
  const reload = (): void => renderApprovals(body);

  body.innerHTML = `
    <div class="channel-header">
      <h1>Approvals</h1>
      <div class="channel-actions">
        <button class="btn btn-primary" id="add-approval">${iconPlus()} Submit Approval</button>
      </div>
    </div>
    <div class="card-list">
      ${approvals.length
        ? approvals.map(a => approvalCard(a)).join('')
        : '<div class="empty-state"><p>No approvals yet</p></div>'}
    </div>`;

  document.getElementById('add-approval')?.addEventListener('click', () => openSubmitApproval(reload));
  body.querySelectorAll<HTMLButtonElement>('[data-action]').forEach(btn => {
    const action = btn.dataset['action'];
    const id = btn.dataset['id'];
    if (action && id && (action === 'approve' || action === 'deny')) {
      btn.addEventListener('click', () => handleAction(action, id, reload));
    }
  });
}
